import CustomMessageAttentionModal from './CustomMessageAttentionModal'

export { buildCustomMessageAttentionCase } from './buildCustomMessageAttentionCase'
export type {
  CustomMessage,
  CustomMessageAttentionCase,
  CustomMessageAttentionModalProps,
} from './types'

export default CustomMessageAttentionModal
